import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DollarSign, Megaphone, Store } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const fmt = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

export default function RevenueCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/admin/revenue-overview`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((res) => setData(res.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const { ads, marketplace: mp } = data;

  return (
    <div className="bg-white rounded-xl shadow-md p-6" data-testid="revenue-card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <DollarSign className="h-5 w-5 text-emerald-600" /> Revenue
        </h3>
        <div className="text-right">
          <p className="text-2xl font-bold text-emerald-600" data-testid="revenue-combined-total">{fmt(data.combined_total)}</p>
          <p className="text-xs text-gray-500">all-time · {fmt(data.combined_30d)} last 30d</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="border border-gray-200 rounded-lg p-4">
          <p className="text-sm font-semibold text-gray-700 flex items-center gap-1.5 mb-2">
            <Megaphone className="h-4 w-4 text-orange-500" /> Ad Income
          </p>
          <p className="text-xl font-bold text-gray-900" data-testid="revenue-ads-total">{fmt(ads.total_revenue)}</p>
          <p className="text-xs text-gray-500 mt-1">{fmt(ads.revenue_30d)} last 30d · {ads.paid_bookings} paid booking{ads.paid_bookings === 1 ? '' : 's'}</p>
        </div>
        <div className="border border-gray-200 rounded-lg p-4">
          <p className="text-sm font-semibold text-gray-700 flex items-center gap-1.5 mb-2">
            <Store className="h-4 w-4 text-blue-600" /> Marketplace Commission
          </p>
          <p className="text-xl font-bold text-gray-900" data-testid="revenue-mp-commission">{fmt(mp.total_commission)}</p>
          <p className="text-xs text-gray-500 mt-1">
            {fmt(mp.commission_30d)} last 30d · {mp.orders_total} order{mp.orders_total === 1 ? '' : 's'} · {fmt(mp.gmv_total)} GMV · {mp.active_listings} active listings
          </p>
        </div>
      </div>

      {data.recent_orders.length > 0 && (
        <div className="mt-4">
          <p className="text-xs font-semibold uppercase text-gray-400 mb-2">Recent marketplace sales</p>
          <div className="divide-y divide-gray-100">
            {data.recent_orders.slice(0, 5).map((o) => (
              <div key={o.id} className="py-1.5 flex items-center justify-between text-sm" data-testid={`revenue-order-${o.id}`}>
                <span className="text-gray-700 truncate mr-3">{o.listing_title}</span>
                <span className="shrink-0 text-gray-500">
                  {fmt(o.amount)} → <span className="font-semibold text-emerald-600">{fmt(o.commission_amount)}</span> fee
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
